import React, { Component } from 'react';
import swal from 'sweetalert';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import { selectMembershipType, selectMembershipPackage, fetchMembershipTypes, fetchMembershipPackages } from '../../../../../../../Redux/Actions/EndUser/MembershipAction';
import { fetchAllMemberships, updateAdminMembership, addAdminMembership } from '../../../../../../../Redux/Actions/Admin/ManageMembershipActions';
import { fetchStates } from '../../../../../../../Redux/Actions/CommonActions';
import { getCounties, setCounties } from '../../../../../../../Redux/Actions/Admin/ManageDistrictActions';
import '../../../ManageMembership/ManageMembership.scss';

import {
    addToPurchase,
    updatePurchase,
    changeView,
    setAlert
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import IsLoading from '../../../../../../Shared/Loading/IsLoading';
import { Alert } from 'reactstrap';

import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../../api-config';
import _ from 'lodash';
import { auth } from '../../../../../../../services';

const initialState = {
    firstRender: false,
    membershipInEdit: {},
    value: [],
    membershipLookup: false,
    membershipLookupEmail: "",
    membershipData: [],
    view: "RenewMembership",
    total: "",
    id: 0,
    UserId: "",
    Name: "",
    ActualCost: 0,
    SuggestedCost: 0,
    firstName: "",
    lastName: "",
    email: "",
    mailingAddress1: "",
    mailingAddress2: "",
    mailingCity: "",
    mailingZip: "",
    mailingStateId: "",
    countyObj: { countyId: 0, countyName: "" },
    county: "",
    phone: "",
    additionalHead: 1,
    fullConcatinatedMembershipString: "",
    isLoading: false,
    touched: {
        organizationName: false,
        firstName: false,
        lastName: false,
        email: false,
        mailingCity: false,
        mailingAddress1: false,
        county: true,
        zip: false,
        phone: false
    }
};

class RenewMembership extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;

        this.delayedCallback = _.debounce(this.checkEmailCall, 1000);
        this.onEmailChange = this.onEmailChange.bind(this);
    }
    componentDidMount() {
        this.props.fetchAllMemberships();
        this.props.fetchMembershipTypes();
        this.props.fetchStates();
        if (this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }

        if (this.props.purchaseAndRenewals.userInfo) {
            this.setState(
                {
                    firstRender: true,
                    membershipLookupEmail: (10000000 + this.props.purchaseAndRenewals.userInfo.membershipId).toString()
                }, () => {
                    this.checkEmailCall();
                }
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.purchaseAndRenewals.editingPurchase !== this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    checkEmailCall() {
        this.setState({ isLoading: true })
        const options = { params: { searchTerm: this.state.membershipLookupEmail }, method: 'GET', headers: auth.authHeader() };
        axios.get(`${ROOT_API_URL}/ManageTransaction/SearchMembership`, options)
            .then((response) => {
                if (response.data.length > 0) {
                    this.setState({
                        membershipData: response.data, isLoading: false
                    },
                        () => this.props.setAlert(true, "Users Found", 'success')
                    );

                    if (this.state.firstRender) {
                        let shouldBreak = false;

                        response.data.map(membership => {
                            if (!shouldBreak && (membership.membershipId == this.props.purchaseAndRenewals.userInfo.membershipId)) {
                                shouldBreak = true;

                                this.props.fetchMembershipPackages(membership.membershipType.membershipTypeID);
                                this.setState({
                                    IsRenewal: true,
                                    selectedMember: membership,
                                    userID: membership.userID,
                                    membershipType: membership.membershipType,
                                    membershipPackage: membership.membershipPackage,
                                    membershipId: membership.membershipId,
                                    organizationName: membership.organizationName,
                                    firstName: membership.firstName,
                                    lastName: membership.lastName,
                                    fullName: membership.fullName,
                                    email: membership.email,
                                    mailingAddress1: membership.mailingAddress1,
                                    mailingAddress2: membership.mailingAddress2,
                                    mailingCity: membership.mailingCity,
                                    mailingZip: membership.mailingZip,
                                    mailingStateId: membership.state.id,
                                    state: membership.state,
                                    countyObj: membership.countyObj,
                                    county: membership.countyObj.countyName || "",
                                    phone: membership.phone,
                                    fullConcatinatedMembershipString: membership.fullConcatinatedMembershipString
                                });
                            }
                        });

                        this.setState({
                            firstRender: false
                        });
                    }

                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else if (response.data.length === 0) {
                    this.setState({
                        ...initialState,
                        membershipLookupEmail: this.state.membershipLookupEmail,
                        membershipData: response.data,
                        isLoading: false
                    },
                        () => this.props.setAlert(true, "No Users Found", 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else {
                    this.setState({
                        ...initialState,
                        membershipLookupEmail: this.state.membershipLookupEmail,
                        isLoading: false
                    },
                        () => this.props.setAlert(true, response.data.message, 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                }
            })
            .catch((response) => {
                this.setState({ isLoading: false }, () => this.props.setAlert(true, response.message, 'danger'))
            });
    }

    onEmailChange = (event) => {
        var userId = '';
        if (auth.isAuthenticated()) {
            userId = auth.getAuthUserId()
        }
        this.setState(
            {
                membershipLookupEmail: event.target.value

            },
            () => {
                this.delayedCallback();
            }

        );
    };

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const newState = Object.assign({}, this.state);
        if (this.state.membershipPackage.description === "3000+ head" && this.state.membershipType.description === "Standard") {
            newState.ActualCost = Number(Number(newState.membershipPackage.cost) + Number(1.36 * this.state.additionalHead));
            newState.SuggestedCost = Number(Number(newState.membershipPackage.cost) + Number(1.36 * this.state.additionalHead));
        } else {
            newState.ActualCost = Number(newState.membershipPackage.cost);
            newState.SuggestedCost = Number(newState.membershipPackage.cost);
        }
        newState.additionalHead = parseInt(newState.additionalHead);
        newState.Name = newState.firstName + " " + newState.lastName;
        this.setState(newState);
        if (this.props.purchaseAndRenewals.editingPurchase.Name) {
            this.props.updatePurchase(newState);
        } else {
            this.props.addToPurchase(newState);
        }
        this.props.changeView({ view: "AddItems" })
    };
    isCustom(item) {
        return item.id === undefined;
    }
    addKey(item) {
        item.id = new Date().getTime();
    }
    onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state;
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            ...edited
        });
    };

    handleMultiSelectChange = (event) => {
        var currentState = { ...this.state };
        currentState.permissions = [...event.target.value];
        this.setState({
            ...currentState
        });
    };

    handleChange = (event) => {
        this.selectedMembershipType(event.target.value);
    }

    selectedMembershipType = (value) => {
        this.props.selectMembershipType(value);
        if (value !== null) {

            const newState = Object.assign({}, this.state);
            newState.membershipType = value;
            newState.membershipPackage = {};
            this.setState(
                newState
            );
            this.props.fetchMembershipPackages(value.membershipTypeID);
        }
    }

    handlePackageChange = (event) => {
        const newState = Object.assign({}, this.state);
        newState.membershipPackage = event.target.value;
        this.setState(newState);
        this.props.selectMembershipPackage(event.target.value);
    }

    handleState = (event) => {
        this.props.getCounties(event.target.value.id);
        const value = event.target.value;
        if (value !== null) {
            this.setState({
                state: value,
                mailingStateId: value.id
            });
        }
    };

    selectCountyInDD = (event) => {
        this.setState({
            countyObj: event.target.value
        })
    }

    handleMembershipSelectChange = (event) => {
        if (event.target.value !== null) {
            this.props.fetchMembershipPackages(event.target.value.membershipType.membershipTypeID);
            this.setState({
                IsRenewal: true,
                selectedMember: event.target.value,
                userID: event.target.value.userID,
                membershipType: event.target.value.membershipType,
                membershipPackage: event.target.value.membershipPackage,
                membershipId: event.target.value.membershipId,
                organizationName: event.target.value.organizationName,
                firstName: event.target.value.firstName,
                lastName: event.target.value.lastName,
                fullName: event.target.value.fullName,
                email: event.target.value.email,
                mailingAddress1: event.target.value.mailingAddress1,
                mailingAddress2: event.target.value.mailingAddress2,
                mailingCity: event.target.value.mailingCity,
                mailingZip: event.target.value.mailingZip,
                mailingStateId: event.target.value.state.id,
                state: event.target.value.state,
                countyObj: event.target.value.countyObj,
                county: event.target.value.countyObj.countyName || "",
                phone: event.target.value.phone,
                fullConcatinatedMembershipString: event.target.value.fullConcatinatedMembershipString
            });
        }
    }

    render() {
        return (
                <div>           
				    <Alert
					    color={this.props.purchaseAndRenewals.color}
					    isOpen={this.props.purchaseAndRenewals.visible}
                        style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
				    >
					    {this.props.purchaseAndRenewals.message}
				    </Alert>
                    <div className="row">
                        <div className="col-md-12">
                            <label htmlFor="exampleEmail" className="label-header">Membership Lookup: </label>
                            <Input name="membershipLookupEmail" id="membershipLookupEmail" value={this.state.membershipLookupEmail}
                                ref={(input) => { this.nameInput = input; }} 
                                onChange={this.onEmailChange}
                                type="text"
                                placeholder="Please enter member ID, email, or name." />
                        </div>
                    </div>
                    {this.state.membershipData.length > 0 ?
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label htmlFor="subscriptionId">Please Select Member</label>
                                <DropDownList data={this.state.membershipData}
                                    textField="fullConcatinatedMembershipString"
                                    dataItemKey="membershipId"
                                    onChange={this.handleMembershipSelectChange}
                                    value={this.state.selectedMember}
                                    allowCustom={false}
                                    filterable={false}
                                    clearButton={false}
                                    width={300}
                                    required={true}
                                />
                            </div>
                        </div> : ""
                    }
                {
                    this.state.isLoading ? (
                        <IsLoading message="Loading User Information" />
                    ) : (
                        <form className="user-form membership-form" onSubmit={this.handleSubmit}>
                            {(this.props.purchaseAndRenewals.editingPurchase.membershipType && this.props.purchaseAndRenewals.editingPurchase.view === "RenewMembership") || this.state.selectedMember ?
                                <div>
                                    {/* <div className="row"> */}

                                    <div className="form-group">
                                        <h2 className="callout">Enter <span className="highlight">Member Information</span></h2>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="membershipType">Membership Type</label>
                                            <DropDownList data={this.props.membership.membershipTypes}
                                                textField="description"
                                                dataItemKey="membershipTypeID"
                                                onChange={this.handleChange}
                                                value={this.state.membershipType}
                                                allowCustom={true}
                                                filterable={false}
                                                clearButton={false}
                                                width={300}
                                                required={true}
                                                name="membershipType"
                                                id="membershipType"
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="membershipPackage">Membership Package</label>
                                            {
                                                this.props.membership.membershipPackages ?
                                                    <DropDownList data={this.props.membership.membershipPackages}
                                                        textField="description"
                                                        dataItemKey="membershipPackageID"
                                                        onChange={this.handlePackageChange}
                                                        value={this.state.membershipPackage}
                                                        allowCustom={true}
                                                        filterable={false}
                                                        clearButton={false}
                                                        width={300}
                                                        required={true}
                                                        name="membershipPackage"
                                                        id="membershipPackage"
                                                    /> 
                                                : ""
                                            }
                                        </div>
                                    </div>
                                    {
                                        this.state.membershipPackage ? 
                                        this.state.membershipPackage.description === "3000+ head" && this.state.membershipType.description === "Standard" ? 
                                            <div className="row">
                                                {/* </div> */}
                                                <div className="membershipID form-group col-md-12">
                                                    <label htmlFor="additionalHead" className="">Add additional head number over 3000.</label>
                                                    <Input
                                                        id="additionalHead"
                                                        min="1"
                                                        type="number"
                                                        value={this.state.additionalHead}
                                                        onChange={this.onDialogInputChange}
                                                        name="additionalHead"
                                                    />
                                                </div>
                                            </div>
                                        : "" : ""
                                    }
                                    <div className="row">
                                        {/* </div> */}
                                        <div className="membershipID form-group col-md-12">
                                            <label htmlFor="organizationName" className="">Family/Group/Organization Name - what name would you like on your membership ID card and magazine?</label>
                                            <Input
                                                id="organizationName"
                                                type="text"
                                                value={this.state.organizationName}
                                                onChange={this.onDialogInputChange}
                                                name="organizationName"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="lastName">Last Name</label>
                                            <Input
                                                required={true}
                                                type="text"
                                                name="lastName"
                                                id="lastName"
                                                value={this.state.lastName || ''}
                                                onChange={this.onDialogInputChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="firstName">First Name</label>
                                            <Input
                                                required={true}
                                                type="text"
                                                name="firstName"
                                                value={this.state.firstName || ''}
                                                onChange={this.onDialogInputChange}
                                                id="firstName"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="email">Email</label>
                                            <Input
                                                required={true}
                                                type="email"
                                                name="email"
                                                id="email"
                                                value={this.state.email || ''}
                                                onChange={this.onDialogInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <h2 className="callout">Enter <span className="highlight">Mailing Address</span></h2>
                                    </div>
                                    <div className="mailingAddressContainer row">
                                        <div className="address1-wrapper form-group col-md-6">
                                            <label htmlFor="mailingAddress1">Address 1</label>
                                            <Input
                                                id="mailingAddress1"
                                                type="text"
                                                value={this.state.mailingAddress1}
                                                onChange={this.onDialogInputChange}
                                                name="mailingAddress1"
                                            />
                                        </div>
                                        <div className="address2-wrapper form-group col-md-6">
                                            <label htmlFor="mailingAddress2">Address 2</label>
                                            <Input
                                                id="mailingAddress2"
                                                type="text"
                                                value={this.state.mailingAddress2}
                                                onChange={this.onDialogInputChange}
                                                name="mailingAddress2"
                                            />
                                        </div>
                                    </div>
                                    <div className="cityStateZip row">
                                        <div className="city-wrapper form-group col-md-3">
                                            <label htmlFor="mailingCity">City</label>
                                            <Input
                                                id="mailingCity"
                                                type="text"
                                                value={this.state.mailingCity}
                                                onChange={this.onDialogInputChange}
                                                name="mailingCity"
                                            />
                                        </div>
                                        <div className="state-wrapper form-group col-md-3">
                                            <label htmlFor="State">State</label>
                                            <DropDownList data={this.props.common.states}
                                                id="State"
                                                name="state"
                                                textField="name"
                                                dataItemKey="id"
                                                onChange={this.handleState}
                                                value={this.state.state}
                                            />
                                        </div>
                                        {
                                            this.props.district.counties.length > 0 ?
                                                <div className="form-group col-md-3">
                                                    <label htmlFor="County" className={this.state.touched.county === '' ? "error" : ""}>County</label>
                                                    <DropDownList data={this.props.district.counties}
                                                        id="County"
                                                        name="county"
                                                        textField="countyName"
                                                        dataItemKey="countyId"
                                                        onChange={this.selectCountyInDD}
                                                        value={this.state.countyObj}
                                                        className={this.state.touched.county && this.state.countyObj.countyName === '' ? "error" : ""}
                                                        onBlur={this.handleBlur('county')}
                                                    />
                                                </div>
                                            : ""
                                        }
                                        <div className="zip-wrapper form-group col-md-3">
                                            <label htmlFor="mailingZip">Zip</label>
                                            <Input
                                                id="mailingZip"
                                                validityStyles={false}
                                                value={this.state.mailingZip}
                                                onChange={this.onDialogInputChange}
                                                name="mailingZip"
                                                pattern="(\d{5}([\-]\d{4})?)"
                                                type="text"
                                                placeholder="12345"
                                                title="Zip Code (Format: 12345 or 12345-6789)"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="phone">Phone</label>
                                            <Input
                                                type="text"
                                                name="phone"
                                                id="phone"
                                                value={this.state.phone || ''}
                                                onChange={this.onDialogInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                : ""}

                            <div className="footer">
                                <div className="form-group">
                                    {(this.props.purchaseAndRenewals.editingPurchase.membershipType && this.props.purchaseAndRenewals.editingPurchase.view === "RenewMembership") || this.state.selectedMember ?
                                        <button type="submit" className="admin-k-button">
                                            <i className="fas fa-save"></i>
                                            <span>SAVE</span>
                                        </button>
                                        : ""}
                                    <button className="admin-k-button" onClick={() => this.props.changeView({ view: "AddItems" })}>
                                        <i className="fas fa-times"></i>
                                        <span>CANCEL</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}
                </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership,
        common: state.common,
        district: state.district,
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    fetchStates,
    fetchAllMemberships,
    fetchMembershipTypes,
    fetchMembershipPackages,
    selectMembershipType,
    selectMembershipPackage,
    addAdminMembership,
    updateAdminMembership,
    addToPurchase,
    updatePurchase,
    changeView,
    setAlert,
    getCounties
})(RenewMembership);